import EnvironmentUtils from '../../utils/environment.utils';
import { AnalyticsConsentOption } from '../analytics/types';
import { GTagEvent } from './types';

export class GtagService {
    private static getGtag(): Gtag.Gtag | undefined {
        if (!EnvironmentUtils.isProd || typeof window === 'undefined' || typeof window.gtag !== 'function') return undefined;
        return window.gtag;
    }

    static updateConsent(consent: AnalyticsConsentOption): void {
        const gtag = this.getGtag();
        if (!gtag) return;

        const storage = consent === 'accepted' ? 'granted' : 'denied';
        const settings: Gtag.ConsentParams = {
            ad_storage: storage,
            ad_user_data: storage,
            ad_personalization: storage,
            analytics_storage: storage,
        };
        gtag('consent', 'update', settings);
    }

    static event(event: GTagEvent | string, params?: Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams | undefined) {
        const gtag = this.getGtag();
        if (gtag) gtag('event', event, params);
    }
}
